import React from 'react';
import {
    DiscoverGalleriesFilterTypes,
    EmptyStateTypes,
    ImageTypes,
    InstrumentCategories,
    PaymentSteps,
    ProjectAssetsType,
    Roles,
    Special,
    StudentStatus,
    SubscriptionPlans
} from './enums';
import {
    audio,
    audioBg,
    categoryColors,
    colorLessonsList,
    disabledLight,
    instructions,
    instructionsBg,
    notation,
    notationBg,
    typoDark,
    video,
    videoBg,
    white,
    whiteboard,
    whiteboardBg
} from "../themes/colors";
import blankIcon from '../assets/images/studio/blank';
import iconBlank from '../assets/images/studio/blank';
import imageStaff from '../assets/images/canvas/staff.png';
import imageDrumline from '../assets/images/canvas/drumline.png';
import imageCharts from '../assets/images/canvas/charts.png';
import imagePiano from '../assets/images/canvas/piano.png';
import imageFourStringsChordDiagram from '../assets/images/canvas/4-strings-chord-diagram.png';
import imageChartsV2 from '../assets/images/canvas/chartsV2.png';
import imageFretboard from '../assets/images/canvas/Guitar-fretboard.png'
import imageTAB from '../assets/images/canvas/TAB-staff.png';
import imageTAB4Strings from '../assets/images/canvas/tab-staff-4-strings.png';
import imageFourStringsChordDiagramV2 from '../assets/images/canvas/4-Strings-Chord-Diagram-v2.png';
import iconStaff from '../assets/images/studio/staff';
import drumlineIcon from '../assets/images/studio/drumline';
import iconDrumline from '../assets/images/studio/drumline';
import chartsIcon from '../assets/images/studio/charts';
import iconCharts from '../assets/images/studio/charts';
import stringIcon from '../assets/images/studio/4strings';
import icon4Strings from '../assets/images/studio/4strings';
import pianoIcon from '../assets/images/studio/piano';
import iconPiano from '../assets/images/studio/piano';
import tutorialLogo from '../assets/images/tutorial/logo-white';
import tutorialStudent from '../assets/images/tutorial/student-white';
import tutorialLesson from '../assets/images/tutorial/lesson-white';
import tutorialEdit from '../assets/images/tutorial/edit-white';
import tutorialWhiteboard from '../assets/images/tutorial/whiteboard-white';
import tutorialRealtime from '../assets/images/tutorial/realtime-white';
import welcomeDesktopImage1 from "../assets/images/OnBoarding/Welcome-gif-1.png";
import welcomeDesktopBg1 from "../assets/images/OnBoarding/bg-1.jpg";
import welcomeMobileImage1 from "../assets/images/OnBoarding/Welcome-gif-M-1B.png";
import welcomeMobileBg1 from "../assets/images/OnBoarding/mobile-bg-1.jpg";
import welcomeDesktopImage2 from "../assets/images/OnBoarding/Welcome-gif-2.png";
import welcomeDesktopBg2 from "../assets/images/OnBoarding/bg-2.jpg";
import welcomeMobileImage2 from "../assets/images/OnBoarding/Welcome-gif-M-2B.png";
import welcomeMobileBg2 from "../assets/images/OnBoarding/mobile-bg-2.jpg";
import welcomeDesktopImage3 from "../assets/images/OnBoarding/Welcome-gif-3.png";
import welcomeDesktopBg3 from "../assets/images/OnBoarding/bg-3.jpg";
import welcomeMobileImage3 from "../assets/images/OnBoarding/Welcome-gif-M-3B.png";
import welcomeMobileBg3 from "../assets/images/OnBoarding/mobile-bg-3.jpg";
import {ReactComponent as audioTabIcon} from '../assets/images/audio-studio-tab.svg'
import {ReactComponent as videoTabIcon} from '../assets/images/video-studio-tab.svg'
import {ReactComponent as notationTabIcon} from '../assets/images/notation-studio-tab.svg'
import {ReactComponent as whiteboardTabIcon} from '../assets/images/whiteboard-studio-tab.svg'
import {ReactComponent as instructionsTabIcon} from '../assets/images/instructions-studio-tab.svg'
import iconTabStaff from "../assets/images/studio/tabStaff";
import iconFretboard from "../assets/images/studio/fretboard";
import icon4Tab from "../assets/images/studio/4stringsTabStaff";
import {ReactComponent as notationMediaIcon} from "../assets/images/studio/notation-gallery.svg";
import {ReactComponent as videoMediaIcon} from "../assets/images/studio/video-gallery.svg";
import {ReactComponent as whiteboardMediaIcon} from "../assets/images/studio/whiteboard-gallery.svg";
import {ReactComponent as AddAssignmentIcon} from '../assets/images/homeTeacher/Add-Assignment.svg';
import {ReactComponent as StudentIcon} from '../assets/images/homeTeacher/student.svg';
import {ReactComponent as NotesIcon} from '../assets/images/homeTeacher/Note.svg';
import {ReactComponent as FolderIcon} from '../assets/images/homeTeacher/add-folder.svg';
import {ReactComponent as VideoIcon} from '../assets/images/homeTeacher/VideoIcon.svg';
import {ReactComponent as MusicoIcon} from "../assets/images/homeTeacher/Musico.svg";
import {ReactComponent as emptyNotesTimelineIcon} from '../assets/images/emptyState/notes-empty.svg'
import {ReactComponent as emptyTimelineIcon} from '../assets/images/emptyState/timeline-empty.svg'
import {ReactComponent as emptyPersonalLibraryIcon} from '../assets/images/emptyState/library-empty.svg'

export const FACEBOOK = 'facebook';
export const CHROME_VENDOR = 'Google Inc.';
export const MINIMUM_RESIZABLE_DIALOG_WIDTH = 300;
export const TRIAL_PERIOD = 14;
export const GRACE_PERIOD = 0;
export const MAX_LOOPER_TRACKS = 7;
export const MAX_ATTACHED_FILES = 5;
export const DEFAULT_AVATAR = '/avatar/default-avatar.jpg';
export const DEFAULT_STEM_IMG = '/media/stem/default/All.jpg';
export const DEFAULT_STEM_LOCATION = '/media/stem/default';
export const BASE_USER_FIELDS = ['name', 'family_name', 'given_name'];
export const NODE_ENV_PRODUCTION = 'production';
export const MUSICO_TOUR_VIDEO_URL = 'https://youtube.com/watch?v=WQT1Plwr0DA&feature=youtu.be';
export const BPM_MIN = 5;
export const BPM_MAX = 240;
export const BPM_DEFAULT = 120;
export const DEFAULT_BEATS_PER_BAR = 4;
export const DEFAULT_BEATS_METER = 4;
export const NUM_TEACHER_PRICING_BULLETS = 6;
export const NUM_STUDENT_PRICING_BULLETS = 7;
export const NUM_ITEMS_PER_PAGE = 20;
export const NUM_GROUPS_PER_PAGE = 5;
export const STEM_ACTION_MAX = 60;
export const MIN_DISCOVERY_LESSON_ACCUMULATED_PLAYING_TIME = 30;
export const RESTRICTED_BUCKET = 'musico-restricted-bucket-v2';
export const AUDIO_RESTRICTED_BUCKET = RESTRICTED_BUCKET
export const ATTACHMENT_BUCKET = RESTRICTED_BUCKET;

export const GOOGLE_API_KEY = 'AIzaSyC8ktmCZTUN9KZ9Opnjo4fEiTWqjBQCYcQ';
export const GOOGLE_CLIENT_ID = '971992900677-2jri711jl3nlo3ktbslf9omhq3lefvbs.apps.googleusercontent.com';

export const SHOW_SYSTEM_ERROR = false;

export const MAX_HEIGHT_FOR_CANVAS_ZOOM = 620;

export const TOAST_AUTO_CLOSE_TIME = 5000;

export const gridDivisionArray = [
    {label: '1/16', value: 4},
    {label: '1/8', value: 2},
    {label: '1/4', value: 1},
    {label: '1/2', value: 0.5},
    {label: '1', value: 0.25},
    {label: '2', value: 0.125},
    {label: '4', value: 0.0625}
];

export const transpositionArray = [
    'A',
    'Bb',
    'B',
    'C',
    'Db',
    'D',
    'Eb',
    'E',
    'F',
    'Gb',
    'G',
    'Ab'
];

export const pitchShiftArray = [
    {label: '-12', value: -12},
    {label: '-11', value: -11},
    {label: '-10', value: -10},
    {label: '-9', value: -9},
    {label: '-8', value: -8},
    {label: '-7', value: -7},
    {label: '-6', value: -6},
    {label: '-5', value: -5},
    {label: '-4', value: -4},
    {label: '-3', value: -3},
    {label: '-2', value: -2},
    {label: '-1', value: -1},
    {label: '0', value: 0},
    {label: '+1', value: 1},
    {label: '+2', value: 2},
    {label: '+3', value: 3},
    {label: '+4', value: 4},
    {label: '+5', value: 5},
    {label: '+6', value: 6},
    {label: '+7', value: 7},
    {label: '+8', value: 8},
    {label: '+9', value: 9},
    {label: '+10', value: 10},
    {label: '+11', value: 11},
    {label: '+12', value: 12}
];

export const TSArray = [
    {label: '2/2', value: [2, 2]},
    {label: '2/4', value: [2, 4]},
    {label: '3/4', value: [3, 4]},
    {label: '4/4', value: [4, 4]},
    {label: '5/4', value: [5, 4]},
    {label: '6/4', value: [6, 4]},
    {label: '3/8', value: [3, 8]},
    {label: '5/8', value: [5, 8]},
    {label: '6/8', value: [6, 8]},
    {label: '9/8', value: [9, 8]},
    {label: '12/8', value: [12, 8]}
];

export const beatsArray = Array.apply(null, {length: 1600}).map(Number.call, Number);
export const bpmArray = Array.apply(null, {length: 300}).map(Number.call, Number);

const baseInstruments = [
    {"name": "Piano", "category": InstrumentCategories.Keyboard, "image": "Piano.jpg"},
    {"name": "Guitar", "category": InstrumentCategories.Strings, "image": "Guitar.jpg"},
    {"name": "Vocals", "category": InstrumentCategories.Vocals, "image": "Vocals.jpg"},
    {"name": "Violin", "category": InstrumentCategories.BowStrings, "image": "Violin.jpg"},
    {"name": "Flute", "category": InstrumentCategories.Woodwinds, "image": "Clarinet.jpg"},
    {"name": "Saxophone", "category": InstrumentCategories.Woodwinds, "image": "Tenor-Saxophone.jpg"},
    {"name": "Drum Set", "category": InstrumentCategories.Drums, "image": "Drum-Set.jpg"},
    {"name": "Other", "category": InstrumentCategories.Other, "image": "general.jpg"}
];

const mainInstruments = [
    {"name": "Baritone Horn", "category": InstrumentCategories.Brass, "image": "Trumpet.jpg"},
    {"name": "Bass Trombone", "category": InstrumentCategories.Brass, "image": "Trumpet.jpg"},
    {"name": "French Horn", "category": InstrumentCategories.Brass, "image": "Trumpet.jpg"},
    {"name": "Harmonica", "category": InstrumentCategories.Brass, "image": "Trumpet.jpg"},
    {"name": "Trombone", "category": InstrumentCategories.Brass, "image": "Trumpet.jpg"},
    {"name": "Trumpet", "category": InstrumentCategories.Brass, "image": "Trumpet.jpg"},
    {"name": "Tuba", "category": InstrumentCategories.Brass, "image": "Trumpet.jpg"},
    {"name": "Organ", "category": InstrumentCategories.Keyboard, "image": "Piano.jpg"},
    {"name": "Percussion", "category": InstrumentCategories.Percussion, "image": "Bongos.jpg"},
    {"name": "Banjo", "category": InstrumentCategories.Strings, "image": "Guitar.jpg"},
    {"name": "Bass", "category": InstrumentCategories.Strings, "image": "Guitar.jpg"},
    {"name": "Cello", "category": InstrumentCategories.BowStrings, "image": "Violin.jpg"},
    {"name": "Contrabass", "category": InstrumentCategories.BowStrings, "image": "Violin.jpg"},
    {"name": "Composition", "category": InstrumentCategories.Other, "image": "general.jpg"},
    {"name": "Harp", "category": InstrumentCategories.Strings, "image": "Harp.jpg"},
    {"name": "Mandolin", "category": InstrumentCategories.Strings, "image": "Guitar.jpg"},
    {"name": "Viola", "category": InstrumentCategories.BowStrings, "image": "Violin.jpg"},
    {"name": "Ukulele", "category": InstrumentCategories.Strings, "image": "Guitar.jpg"},
    {"name": "Bassoon", "category": InstrumentCategories.Woodwinds, "image": "Clarinet.jpg"},
    {"name": "Clarinet", "category": InstrumentCategories.Woodwinds, "image": "Clarinet.jpg"},
    {"name": "Oboe", "category": InstrumentCategories.Woodwinds, "image": "Clarinet.jpg"}
];
export const MULTIPLE_INSTRUMENTS = 'Multiple All';
export const secondaryInstruments = [
    {"name": "Air horn", "category": InstrumentCategories.Brass, "image": "Trumpet.jpg"},
    {"name": "Euphonium", "category": InstrumentCategories.Brass, "image": "Trumpet.jpg"},
    {"name": "Horn", "category": InstrumentCategories.Brass, "image": "Trumpet.jpg"},
    {"name": "Sousaphone", "category": InstrumentCategories.Brass, "image": "Trumpet.jpg"},
    {"name": "Tube Trumpet", "category": InstrumentCategories.Brass, "image": "Trumpet.jpg"},
    {"name": "Drum Machine", "category": InstrumentCategories.Drums, "image": "Drum-Set.jpg"},
    {"name": "Electronic Beat", "category": InstrumentCategories.Drums, "image": "Drum-Set.jpg"},
    {"name": "Accordion", "category": InstrumentCategories.Keyboard, "image": "Accordion.jpg"},
    {"name": "Electric Piano", "category": InstrumentCategories.Keyboard, "image": "Piano.jpg"},
    {"name": "Melodica", "category": InstrumentCategories.Keyboard, "image": "Piano.jpg"},
    {"name": "Cowbell", "category": InstrumentCategories.Percussion, "image": "Bongos.jpg"},
    {"name": "Shaker", "category": InstrumentCategories.Percussion, "image": "Bongos.jpg"},
    {"name": "Steel Drums", "category": InstrumentCategories.Percussion, "image": "Bongos.jpg"},
    {"name": "Tabla", "category": InstrumentCategories.Percussion, "image": "Bongos.jpg"},
    {"name": "Triangle", "category": InstrumentCategories.Percussion, "image": "Bongos.jpg"},
    {"name": "Tambourine", "category": InstrumentCategories.Percussion, "image": "Bongos.jpg"},
    {"name": "Xylophone", "category": InstrumentCategories.Percussion, "image": "Bongos.jpg"},
    {"name": "Double Bass", "category": InstrumentCategories.Strings, "image": "Guitar.jpg"},
    {"name": "Sitar", "category": InstrumentCategories.Strings, "image": "Guitar.jpg"},
    {"name": "Electronic Keyboard", "category": InstrumentCategories.Synth, "image": "Synth.jpg"},
    {"name": "Synthesizer", "category": InstrumentCategories.Synth, "image": "Synth.jpg"},
    {"name": "Cornet", "category": InstrumentCategories.Woodwinds, "image": "Clarinet.jpg"},
    {"name": "English Horn", "category": InstrumentCategories.Woodwinds, "image": "Clarinet.jpg"},
    {"name": "Piccolo", "category": InstrumentCategories.Woodwinds, "image": "Clarinet.jpg"},
    {"name": "Recorder", "category": InstrumentCategories.Woodwinds, "image": "Clarinet.jpg"},
    {"name": MULTIPLE_INSTRUMENTS, "category": InstrumentCategories.Other, "image": "", hideForNonAdmin: true}
];

export const instruments =
    baseInstruments.concat(mainInstruments).concat(secondaryInstruments).sort((a, b) => {
        if (a.name === MULTIPLE_INSTRUMENTS) {
            return -1;
        } else if (b.name === MULTIPLE_INSTRUMENTS) {
            return 1;
        } else {
            return a.name.toLowerCase() - b.name.toLowerCase()
        }
    });

export const instrumentsForUsers = instruments.filter(i => !i.hideForNonAdmin);

export const onboardingInstruments =
    baseInstruments.concat(
        mainInstruments.slice().sort((a, b) => {
            return a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1;
        }))



export const genres = [
    {name: 'African'},
    {name: 'Asian'},
    {name: 'Avant-garde'},
    {name: 'Blues'},
    {name: 'Classical'},
    {name: 'Country'},
    {name: 'Easy listening'},
    {name: 'EDM'},
    {name: 'Electronic'},
    {name: 'Ethnic'},
    {name: 'Folk'},
    {name: 'Funk'},
    {name: 'Hip hop'},
    {name: 'Jazz'},
    {name: 'Latin'},
    {name: 'Metal'},
    {name: 'Old School'},
    {name: 'Pop'},
    {name: 'R&B'},
    {name: 'Rap'},
    {name: 'Reggae'},
    {name: 'Rock'},
    {name: 'Soul'}
];

export const scale = [
    {name: 'Major'},
    {name: 'Minor'}
];

export const keys = [
    {name: 'A'},
    {name: 'Bb'},
    {name: 'B'},
    {name: 'C'},
    {name: 'Db/C#'},
    {name: 'D'},
    {name: 'Eb'},
    {name: 'E'},
    {name: 'F'},
    {name: 'Gb/F#'},
    {name: 'G'},
    {name: 'Ab'}
];

export const levels = [
    {name: 'beginner', bgImg: 'beginner', showOnHomePage: true},
    {name: 'easy', showOnHomePage: false},
    {name: 'intermediate', showOnHomePage: false},
    {name: 'advanced', showOnHomePage: false}
];

export const lessonCategories = [
    {name: 'techniqueExercises', color: categoryColors[4], bgImg: 'theory',},
    {name: 'classical', color: categoryColors[0], bgImg: 'classical'},
    {name: 'jazzStandards', color: categoryColors[1], bgImg: 'jazz'},
    {name: 'famousSongs', color: categoryColors[2], bgImg: 'pop'},
    {name: 'traditional', color: categoryColors[5], bgImg: 'children'},
    {name: 'moviesTVGames', color: categoryColors[7], bgImg: 'movies'},
    {name: 'disney', color: categoryColors[8], bgImg: 'disney'},
    {name: 'musicals', color: categoryColors[0], bgImg: 'musicals'},
    {name: 'holidayReligion', color: categoryColors[1], bgImg: 'holiday'},
    {name: 'country', color: categoryColors[2], bgImg: 'country'},
    {name: 'classicEnsemble', color: categoryColors[6], bgImg: 'chamber'},
    {name: 'hipHopRap', color: categoryColors[3], bgImg: 'rap'},
    {name: 'methods', color: categoryColors[3], bgImg: 'exam'}
];


export const timeArray = [
    {label: '12:00am', value: '00:00'},
    {label: '1:00am', value: '01:00'},
    {label: '2:00am', value: '02:00'},
    {label: '3:00am', value: '03:00'},
    {label: '4:00am', value: '04:00'},
    {label: '5:00am', value: '05:00'},
    {label: '6:00am', value: '06:00'},
    {label: '7:00am', value: '07:00'},
    {label: '8:00am', value: '08:00'},
    {label: '9:00am', value: '09:00'},
    {label: '10:00am', value: '10:00'},
    {label: '11:00am', value: '11:00'},
    {label: '12:00pm', value: '12:00'},
    {label: '1:00pm', value: '13:00'},
    {label: '2:00pm', value: '14:00'},
    {label: '3:00pm', value: '15:00'},
    {label: '4:00pm', value: '16:00'},
    {label: '5:00pm', value: '17:00'},
    {label: '6:00pm', value: '18:00'},
    {label: '7:00pm', value: '19:00'},
    {label: '8:00pm', value: '20:00'},
    {label: '9:00pm', value: '21:00'},
    {label: '10:00pm', value: '22:00'},
    {label: '11:00pm', value: '23:00'}
];

export const emptyAssignmentsArray = [
    {name: '1st Assignment : Basic Scales', backgroundImg: ''},
    {name: '2nd Assignment : Technique', backgroundImg: ''},
    {name: '3rd Assignment : Play The Whole 9th Symphony', backgroundImg: ''}
];

export const emptyAssignment = {
    name: 'Create your first warm-up exercise',
    backgroundImg: '',
    practiceTime: []
};

export const emptyLessonsArray = [
    {name: 'Create your first warm-up exercise', backgroundImg: ''},
    {name: 'And maybe also a theory lesson', backgroundImg: ''},
    {name: 'Another one to improve some skills', backgroundImg: ''},
    {name: 'Jazz or Blues? You decide!', backgroundImg: ''},
    {name: 'Ear Training like a pro', backgroundImg: ''},
    {name: 'Add your favorite song', backgroundImg: ''},
    {name: 'What’s your favorite Broadway tune?', backgroundImg: ''}
];

export const emptyProjectsArray = [
    {name: 'My Pop Piano', backgroundImg: ''},
    {name: 'My Screeching Guitar', backgroundImg: ''},
    {name: 'My Heavy Bass', backgroundImg: ''},
    {name: 'My Lyric Strings', backgroundImg: ''},
    {name: 'My Funky Beat', backgroundImg: ''}
];

export const fakeStudents = [
    {name: 'Johanna Sebastian', avatar: require('../assets/images/avatars/2.jpg'), id: 'fake1', email: 1, status: StudentStatus.Fake},
    {name: 'Ziggy Stardust', avatar: require('../assets/images/avatars/5.jpg'), id: 'fake3', email: 3, status: StudentStatus.Fake},
    {name: 'Eleanor Rigby', avatar: require('../assets/images/avatars/4.jpg'), id: 'fake2', email: 2, status: StudentStatus.Fake},
    {name: 'Rocky Raccoon', avatar: require('../assets/images/avatars/6.jpg'), id: 'fake4', email: 4, status: StudentStatus.Fake},
    {name: 'Timmy Thornton', avatar: require('../assets/images/avatars/3.jpg'), id: 'fake5', email: 5, status: StudentStatus.Fake},
    {name: 'Draco Malfoy', avatar: require('../assets/images/avatars/3.jpg'), id: 'fake6', email: 6, status: StudentStatus.Fake},
    {name: 'Frodo Baggins', avatar: require('../assets/images/avatars/3.jpg'), id: 'fake7', email: 7, status: StudentStatus.Fake}
];

export const uneditableStudentTypes = [StudentStatus.Demo];

const tutorialsBucket = 'https://s3.eu-central-1.amazonaws.com/musico-public-bucket/tutorials/';
export const supportVideoCollection = [
    {
        name: 'Adding a new student',
        url: `${tutorialsBucket}Musico-1-add-student.mp4`,
        role: Roles.Teacher
    },
    {
        name: 'Student assignments page overview',
        url: `${tutorialsBucket}Musico-2-student-assignments-page.mp4`,
        role: Roles.Teacher
    },
    {
        name: 'Studio: using the recorder',
        url: `${tutorialsBucket}Musico-3-studio-recorder.mp4`,
        role: Roles.Teacher
    },
    {
        name: 'Studio: using the sample bank',
        url: `${tutorialsBucket}Musico-4-studio-sample-bank.mp4`,
        role: Roles.Teacher
    },
    {
        name: 'Studio: lesson media & info',
        url: `${tutorialsBucket}Musico-5-studio-lesson-media.mp4`,
        role: Roles.Teacher
    },
    {
        name: 'Studio: music editing features',
        url: `${tutorialsBucket}Musico-6-studio-edit-loop.mp4`,
        role: Roles.Teacher
    },
    {
        name: 'Discover Musico lessons page overview',
        url: `${tutorialsBucket}Musico-8-discover-overview.mp4`,
        role: Roles.Teacher
    },
    {
        name: 'How your student sees Musico',
        url: `${tutorialsBucket}Musico-7-view-as-student.mp4`,
        role: Roles.Teacher
    },
    {
        name: 'Getting started',
        url: `${tutorialsBucket}Student-1-getting-started.mp4`,
        role: Roles.Student
    },
    {
        name: 'How to practice an assignment',
        url: `${tutorialsBucket}Student-2-practice-assignment.mp4`,
        role: Roles.Student
    },
    {
        name: 'How to discover Musico bonus lessons',
        url: `${tutorialsBucket}Student-3-discover-lessons.mp4`,
        role: Roles.Student
    },
    {
        name: 'How to create your own projects',
        url: `${tutorialsBucket}Student-4-project.mp4`,
        role: Roles.Student
    }
];

export const wikiApi = 'https://en.wikipedia.org/api/rest_v1/page/summary/';
export const wikiUrl = 'https://en.wikipedia.org/wiki/';

export const SCHOOL_TEACHERS = 'teachers';
export const SCHOOL_STUDENTS = 'students';

const buttonNextDisabled = {
    color: white,
    backgroundColor: disabledLight,
    cursor: 'pointer',
    pointerEvents: 'none'
}

export const STUDENT_VIDEO_URL = 'https://youtu.be/o9YTfjpW-PM';


export const PROJECT_ASSETS = [
    {
        type: ProjectAssetsType.Text,
        label: 'Overview',
        color: instructions,
        bgColor: instructionsBg,
        icon: instructionsTabIcon,
        iconViewBox: '0 0 38 38',
        isEditable: false
    },
    {
        type: ProjectAssetsType.Notation,
        label: 'Notation',
        color: notation,
        bgColor: notationBg,
        icon: notationTabIcon,
        mediaIcon: notationMediaIcon,
        mediaTitle: 'studio.assets.header.file',
        mediaTitlePlural: 'studio.assets.header.files',
        iconViewBox: '0 0 38 38',
        isEditable: false,
    },
    {
        type: ProjectAssetsType.Audio,
        label: 'Audio',
        color: audio,
        bgColor: audioBg,
        icon: audioTabIcon,
        iconViewBox: '0 0 40 40',
        isEditable: false
    },
    {
        type: ProjectAssetsType.Video,
        label: 'Video',
        color: video,
        bgColor: videoBg,
        icon: videoTabIcon,
        mediaIcon: videoMediaIcon,
        mediaTitle: 'studio.assets.header.video',
        mediaTitlePlural: 'studio.assets.header.videos',
        iconViewBox: '0 0 20 20',
        isEditable: false
    },
    {
        type: ProjectAssetsType.Image,
        label: 'Whiteboard',
        color: whiteboard,
        bgColor: whiteboardBg,
        icon: whiteboardTabIcon,
        mediaIcon: whiteboardMediaIcon,
        mediaTitle: 'studio.assets.header.board',
        mediaTitlePlural: 'studio.assets.header.boards',
        iconViewBox: '0 0 64 64',
        isEditable: true
    }
];

export const PROJECT_SKILLS = [
    {
        type: 'notationReading',
        value: 1
    },
    {
        type: 'rhythm',
        value: 1
    },
    {
        type: 'theory',
        value: 1
    },
    {
        type: 'technique',
        value: 1
    },
    {
        type: 'dynamics',
        value: 1
    },
    {
        type: 'teamPlaying',
        value: 1
    },
    {
        type: 'harmony',
        value: 1
    },
    {
        type: 'earTraining',
        value: 1
    },
    {
        type: 'improvisation',
        value: 1
    },
    {
        type: 'composition',
        value: 1
    },
    {
        type: 'production',
        value: 1
    },
    {
        type: 'tone',
        value: 1
    }
];

export const monthlyReferrerCoupon = 'MUSICOREF';
export const yearlyReferrerCoupon = 'MUSICOREFY';
export const birthdayCoupon = 'MUSICOBIRTHDAY';

export const BIRTHDAY_DISCOUNT = 1 - 0.3;

export const SUBSCRIPTION_PLANS = [
    {
        key: SubscriptionPlans.Free,
        color: '#535878',
        min: -1,
        max: -1,
        yearly: 0,
        monthly: 0,
        referrerCoupon: {monthly: monthlyReferrerCoupon, yearly: yearlyReferrerCoupon}
    },
    {
        key: SubscriptionPlans.Basic,
        min: -1,
        max: -1,
        default: 4,
        yearly: 4 * BIRTHDAY_DISCOUNT,
        monthly: 5 * BIRTHDAY_DISCOUNT,
        productId: {yearly: process.env.REACT_APP_PAYMENT_BASIC_YEARLY, monthly: process.env.REACT_APP_PAYMENT_BASIC_MONTHLY},
        color: '#9D185F',
        referrerCoupon: {monthly: monthlyReferrerCoupon, yearly: yearlyReferrerCoupon}
    },
    {
        key: SubscriptionPlans.Academy,
        min: -1,
        max: -1,
        default: 35,
        yearly: 3.2 * BIRTHDAY_DISCOUNT,
        monthly: 4 * BIRTHDAY_DISCOUNT,
        productId: {yearly: process.env.REACT_APP_PAYMENT_ACADEMY_YEARLY, monthly: process.env.REACT_APP_PAYMENT_ACADEMY_MONTHLY},
        color: '#F77927',
        referrerCoupon: {monthly: monthlyReferrerCoupon, yearly: yearlyReferrerCoupon}
    },
    {
        key: SubscriptionPlans.Conservatory,
        min: -1,
        max: -1,
        default: 75,
        yearly: 2.8 * BIRTHDAY_DISCOUNT,
        monthly: 3.5 * BIRTHDAY_DISCOUNT,
        productId: {yearly: process.env.REACT_APP_PAYMENT_CONSERVATORY_YEARLY, monthly: process.env.REACT_APP_PAYMENT_CONSERVATORY_MONTHLY},
        color: '#9E73AF',
        referrerCoupon: {monthly: monthlyReferrerCoupon, yearly: yearlyReferrerCoupon}
    },
    {
        key: SubscriptionPlans.School,
        color: '#009D92',
        min: -1,
        max: -1,
    },
    {
        key: SubscriptionPlans.Unlimited,
        min: 0,
        max: Infinity,
        color: typoDark,
        yearly: 16.5,
        monthly: 20,
        productId: {yearly: process.env.REACT_APP_PAYMENT_UNLIMITED_YEARLY, monthly: process.env.REACT_APP_PAYMENT_UNLIMITED_MONTHLY},
        referrerCoupon: {monthly: monthlyReferrerCoupon, yearly: yearlyReferrerCoupon}
    },
    {
        key: SubscriptionPlans.Trial,
        color: typoDark
    },
    {
        key: SubscriptionPlans.Custom,
        color: '#009D92',
        min: 0,
        max: Infinity,
    },
];

export const DEFAULT_SUBSCRIPTION_PLAN = SUBSCRIPTION_PLANS[5];


export const PAYMENT_NAV = [
    {
        key: PaymentSteps.Plan,
        active: false,
        disable: false,
    },
    {
        key: PaymentSteps.Seats,
        active: true,
        disable: false,
    },
    {
        key: PaymentSteps.Purchase,
        active: false,
        disable: true,
    }
];

export const TEACHER_TUTORIAL_VIDEOS = [
    {
        key: 'header.video.tutorials.title1',
        url: 'https://youtu.be/RvxA1cwCqys',
        icon: tutorialLogo,
    }, {
        key: 'header.video.tutorials.title2',
        url: 'https://youtu.be/1KjkkhfoC8c',
        icon: tutorialStudent,
    }, {
        key: 'header.video.tutorials.title3',
        url: 'https://youtu.be/gHpOAkva_PA',
        icon: tutorialLesson,
    }, {
        key: 'header.video.tutorials.title4',
        url: 'https://youtu.be/qjGpOAOWbxU',
        icon: tutorialEdit,
    }, {
        key: 'header.video.tutorials.title5',
        url: 'https://youtu.be/QcHlMLT7-pg',
        icon: tutorialWhiteboard,
    }, {
        key: 'header.video.tutorials.title6',
        url: 'https://youtu.be/o9YTfjpW-PM',
        icon: tutorialRealtime,
    }
];

export const WHITEBOARD_TEMPLATES = [
    {
        key: 'studio.assets.images.piano',
        icon: pianoIcon,
    },
    {
        key: 'studio.assets.images.charts',
        icon: chartsIcon,
    },
    {
        key: 'studio.assets.images.4-strings-chord-diagram',
        icon: stringIcon,
    },
    {
        key: 'studio.assets.images.staff',
        icon: iconStaff,
    },
    {
        key: 'studio.assets.images.drumline',
        icon: drumlineIcon,
    },
    {
        key: 'studio.assets.images.blank',
        icon: blankIcon,
    }
];

export const STUDENT_TUTORIAL_VIDEOS = [
    {
        key: 'header.video.tutorials.student.title1',
        url: 'https://youtu.be/YCPn21gbXsg'
    }, {
        key: 'header.video.tutorials.student.title2',
        url: 'https://youtu.be/UVmk2-cwQ50'
    }, {
        key: 'header.video.tutorials.student.title3',
        url: 'https://youtu.be/jmqtRBFzsIc'
    }, {
        key: 'header.video.tutorials.student.title4',
        url: 'https://youtu.be/xqHEXy7idEU'
    }, {
        key: 'header.video.tutorials.student.title5',
        url: 'https://youtu.be/b2I4xEn97H0'
    }
];

export const EMPTY_DISCOVER_DATA = ['1', '2', '3', '4', '5', '6', '7', '8'];

export function getColorByCategory(category: String) {
    try {
        return lessonCategories.find(c => c.name === category).color;
    } catch (err) {
        return categoryColors[0]
    }
}

export function canvasTemplateUrl(type) {
    switch (type) {
        case ImageTypes.Staff:
            return imageStaff;
        case ImageTypes.Drumline:
            return imageDrumline;
        case ImageTypes.Charts:
            return imageCharts;
        case ImageTypes.ChartsV2:
            return imageChartsV2;
        case ImageTypes.Piano:
            return imagePiano;
        case ImageTypes.FourStringsChordDiagram:
            return imageFourStringsChordDiagram;
        case ImageTypes.FourStringsChordDiagramV2:
            return imageFourStringsChordDiagramV2;
        case ImageTypes.FretBoard:
            return imageFretboard
        case ImageTypes.GuitarTab :
            return imageTAB
        case ImageTypes.FourStringsTABstaff :
            return imageTAB4Strings
        default:
            return '';
    }
}

export const special = Special.None;
export const specialDiscount = Special.Birthday;

export const specialCollectionsName = 'Love, love, love';

export const findColorKeyByOldColor = (oldColor) => {
    const key = Object.keys(BANNER_COLORS).find(color => BANNER_COLORS[color].colorOld === oldColor);
    return key || "orange"
}

export const BANNER_COLORS = {
    orange: {color: "#EF6C00", colorEnd: "#FF9D3F", colorOld: "#F77927"},
    yellow: {color: "#F9A825", colorEnd: "#FFD95A", colorOld: "#F0B318"},
    green: {color: "#03A678", colorEnd: "#55D8A7", colorOld: "#A0BE55"},
    audio: {color: "#00838F", colorEnd: "#4FB3BF", colorOld: "#009D92"},
    instructions: {color: "#6797D8", colorEnd: "#99C7FF", colorOld: "#6B93CD"},
    notation: {color: "#8E44AD", colorEnd: "#C073DF", colorOld: "#9E73AF"},
    video: {color: "#AD1457", colorEnd: "#E35183", colorOld: "#9D185F"},
    whiteboard: {color: "#F26663", colorEnd: "#FF9891", colorOld: "#FD9698"},
}

export const SCREEN_WIDTH = {
    desktop: 1280,
    tablet: 1150,
    mobile: 896,
    ipad: 1024
}

export const onboardingImages = [
    {
        image: welcomeDesktopImage1,
        bg: welcomeDesktopBg1,
        mobileImage: welcomeMobileImage1,
        mobileBg: welcomeMobileBg1,
    },
    {
        image: welcomeDesktopImage2,
        bg: welcomeDesktopBg2,
        mobileImage: welcomeMobileImage2,
        mobileBg: welcomeMobileBg2,
    },
    {
        image: welcomeDesktopImage3,
        bg: welcomeDesktopBg3,
        mobileImage: welcomeMobileImage3,
        mobileBg: welcomeMobileBg3,
    },
];

export const newTopic = () => {
    const allColors = Object.keys(BANNER_COLORS);
    return {text: '', color: allColors[Math.floor(Math.random() * allColors.length)]};
}


export const HOW_DO_YOU_TEACH = 'howDoYouTeach';
export const HOW_MANY_STUDENTS = 'howManyStudents';
export const INSTRUMENTS_LIST = 'instruments';
export const ONBOARDING_ROLE = 'onboardingRole';


export const intercomLink = "https://intercom.help/musico/en/"
export const intercomStudentLink = "https://intercom.help/musico/en/collections/2965373-working-with-students"


export const WHITEBOARD_ACTIONS = [
    {
        name: 'blank',
        icon: iconBlank,
        key: 'studio.assets.images.blank',
        type: ImageTypes.Blank
    },
    {
        name: 'staff',
        icon: iconStaff,
        key: 'studio.assets.images.staff',
        type: ImageTypes.Staff
    },
    {
        name: 'piano',
        icon: iconPiano,
        key: 'studio.assets.images.piano',
        type: ImageTypes.Piano
    },
    {
        name: 'charts',
        icon: iconCharts,
        key: 'studio.assets.images.charts',
        type: ImageTypes.ChartsV2
    },
    {
        name: 'guitarTab',
        icon: iconTabStaff,
        key: 'studio.assets.images.guitarTab',
        type: ImageTypes.GuitarTab
    },
    {
        name: 'guitarFret',
        icon: iconFretboard,
        key: 'studio.assets.images.guitarFret',
        type: ImageTypes.FretBoard
    },
    {
        name: 'charts',
        icon: icon4Strings,
        key: 'studio.assets.images.4-strings-chord-diagram',
        type: ImageTypes.FourStringsChordDiagramV2
    },
    {
        name: 'charts',
        icon: icon4Tab,
        key: 'studio.assets.images.4-strings-tab-diagram',
        type: ImageTypes.FourStringsTABstaff
    },
    {
        name: 'drumline',
        icon: iconDrumline,
        key: 'studio.assets.images.drumline',
        type: ImageTypes.Drumline
    }
]

export const GALLERIES_LIST = {
    [DiscoverGalleriesFilterTypes.RecentlyAdded]: {
        title: 'discover.gallery.recentlyAdded',
        filterIndex: 0
    },
    [DiscoverGalleriesFilterTypes.Beginner]: {
        title: 'discover.gallery.beginner',
        filterIndex: 1
    },
    [DiscoverGalleriesFilterTypes.TheoryAndExercises]: {
        title: 'discover.gallery.theory',
        filterIndex: 5
    },
    [DiscoverGalleriesFilterTypes.Disney]: {
        title: 'discover.gallery.disney',
        filterIndex: 9
    },
    [DiscoverGalleriesFilterTypes.PopAndRock]: {
        title: 'discover.gallery.popAndRock',
        filterIndex: 3
    }
}

export const HOMEPAGE_ACTIONS = [
    {
        title: 'homepage.action.studentTimeline',
        description: 'homepage.action.studentTimeline.description',
        themeColor: colorLessonsList[4],
        icon: StudentIcon,
        showOnDesktop: true
    },
    {
        title: 'homepage.action.assignAndShare',
        description: 'homepage.action.assignAndShare.description',
        themeColor: colorLessonsList[0],
        icon: AddAssignmentIcon,
        showOnDesktop: true
    },
    {
        title: 'homepage.action.notes',
        description: 'homepage.action.notes.description',
        themeColor: colorLessonsList[3],
        icon: NotesIcon,
        showOnDesktop: true
    },
    {
        title: 'homepage.action.addToLibrary',
        description: 'homepage.action.addToLibrary.description',
        themeColor: colorLessonsList[8],
        icon: FolderIcon,
        showOnDesktop: true
    },
    {
        title: 'homepage.action.videoLesson',
        description: 'homepage.action.videoLesson.description',
        themeColor: colorLessonsList[1],
        icon: VideoIcon,
        showOnDesktop: true
    },
    {
        title: 'homepage.action.findPremadeContent',
        description: 'homepage.action.findPremadeContent.description',
        themeColor: colorLessonsList[2],
        icon: MusicoIcon,
        showOnDesktop: false
    }
]

export const ADD_STUDENT_CARD = {
    name: 'home.student.add',
    id: 'addStudent',
    selected: false,
    addStudent: true
}

export const QUERY_PARAMS = {
    timelineFilter: 'timelineFilter'
}

export const demoStudentName = 'Demo Student'

export const EMPTY_STATES = {
    [EmptyStateTypes.StudentTimeline]: {Icon: emptyTimelineIcon, label: "empty.state.timeline.student", subLabel: "empty.state.timeline.student.sub"},
    [EmptyStateTypes.TeacherTimeline]: {
        Icon: emptyTimelineIcon,
        label: "empty.state.timeline",
        subLabel: "empty.state.timeline.teacher.sub",
        mobileSubLabel: "empty.state.timeline.sub.mobile"
    },
    [EmptyStateTypes.PersonalLibrary]: {Icon: emptyPersonalLibraryIcon, label: "empty.state.personal.library", subLabel: "empty.state.personal.library.sub"},
    [EmptyStateTypes.NotesTimeline]: {Icon: emptyNotesTimelineIcon, label: "empty.state.timeline.notes", subLabel: "empty.state.timeline.notes.sub"},
}

export const STUDENT_STATUS_INFO = {
    [StudentStatus.Invited]: {status: 'manage.student.status.invited', info: 'general.status.connected.invited'},
    [StudentStatus.Activated]: {status: 'manage.student.status.activated', info: 'general.status.connected.activated'},
    [StudentStatus.NotInvited]: {status: 'manage.student.status.notInvited', info: 'general.status.connected.notInvited'},
}

export const notebookThemes = [
    {
        title: 'general.default',
        theme: 'default'
    },
    {
        title: 'themes.nature',
        theme: 'nature',
    },
    {
        title: 'themes.space',
        theme: 'space',
    },
    {
        title: 'themes.circus',
        theme: 'circus',
    },
    {
        title: 'themes.underwater',
        theme: 'underwater',
    },
    {
        title: 'themes.jazz',
        theme: 'jazz',
    }
]

export const musicoAvatarCategories = [
    {
        title: 'avatar.abstract',
        category: 'abstract',
        numOfItems: 12
    },
    {
        title: 'avatar.animals',
        category: 'animals',
        numOfItems: 12
    },
    {
        title: 'avatar.monsters',
        category: 'monsters',
        numOfItems: 12
    },
    {
        title: 'avatar.robots',
        category: 'robots',
        numOfItems: 12
    }
]